module.exports = __webpack_public_path__ + "static/media/ADYA.gif.200ebab8.gif";